import React, { useEffect, useState } from "react";
import * as moment from "moment";

import cardicon from "../../../../../assets/card-icon.svg";
import savestfundfrombank from "../../../../../assets/savestfundfrombank.svg";
import paymentmethod from "../../../../../assets/Payment System Logo.svg";
import { Util } from "../../../../../../../../helpers/util";
import { $api } from "../../../../../../../../helpers/$api";
import { PaymentMethodCard } from "../../../../../../../shared/payment-method-card/payment-method-card";
const PaymentMethod = ({ setMenu }) => {
  const [ovest, setOvest] = useState("0");
  const [dollar, setDollar] = useState("0");
  const [cards, setCards] = useState([]);
  const [payment_method, setPaymentMethod] = useState("ovest_wallet");
  const [card_id, setCardId] = useState("");
  const { currency } = Util.getCurrency();

  const payload = Util.get("create_flexible_plan");

  const handlePaymentmethodClick = (payment_method, card_id, meta) => {
    setPaymentMethod(payment_method);
    Util.set("create_flexible_plan", { ...payload, payment_method });

    if (card_id) {
      setCardId(card_id);
      Util.set("create_flexible_plan", {
        ...payload,
        payment_method,
        card_id,
        meta,
      });
    }
    setMenu(4);
  };

  useEffect(() => {
    (async () => {
      try {
        const { ovest, dollar_wallet } = await $api.user.getBalances();
        const cards = await $api.user.getUserCards();

        setCards(cards);
        setOvest(ovest);
        setDollar(dollar_wallet);
      } catch (error) {
        // error...
      }
    })();
  }, [setOvest, setCards]);

  return (
    <div className="startinvestment-body">
      <div className="startinvestment-main">
        <div className="paymentmethod-main">
          <h5 className="paymentmethod-header">Payment</h5>
          <div
            className="payment-cards"
            onClick={() => handlePaymentmethodClick("ovest_wallet")}
          >
            <PaymentMethodCard
              icon={cardicon}
              name={"OVest Wallet"}
              balance={`${currency} ${Util.formatMoneyNumber(ovest)}`}
            />
          </div>
          <div
            className="payment-cards"
            onClick={() => handlePaymentmethodClick("dollar_wallet")}
          >
            <PaymentMethodCard
              icon={cardicon}
              name={"OVest Dollar Wallet"}
              balance={`$ ${Util.formatMoneyNumber(dollar)}`}
            />
          </div>

          <div className="payment-cards">
            <PaymentMethodCard
              icon={savestfundfrombank}
              name={"Fund from bank"}
            />
          </div>
          <div className="select-cards">
            <p className="select-cards-p">Select Cards</p>
          </div>
          {cards.map((card) => {
            const [, last_four] = card.card.split("*****");

            return (
              <>
                <div className="card-selection">
                  <div className="payment-radio">
                    <input
                      type="radio"
                      id="html"
                      name="fav_language"
                      value="HTML"
                      onClick={() => {
                        handlePaymentmethodClick("card", card.id, {
                          name: `${card.firstname} ${card.lastname}`,
                          last_four,
                        });
                      }}
                      checked={payment_method === "card" && card_id === card.id}
                    />
                  </div>
                  <div className="payment-bank">
                    <p className="payment-bank-p1">
                      Ending in: **** {last_four}
                    </p>
                    <p className="payment-bank-p2">
                      {card.firstname} {card.lastname}
                    </p>
                    <p className="payment-bank-p3">
                      Last time used:{" "}
                      {moment(card.updated_at).format("ddd MMM DD, YYYY")}
                    </p>
                  </div>
                  <div className="payment-method-img">
                    <img src={paymentmethod} alt="" />
                  </div>
                </div>
                <hr />
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
